import React from "react";

export default (WrappedComponent) =>
  class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        width: window.innerWidth,
      };
      this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount() {
      this.handleResize();
      window.addEventListener("resize", this.handleResize);
    }

    componentWillUnmount() {
      window.removeEventListener("resize", this.handleResize);
    }

    handleResize() {
      this.setState({
        width: window.innerWidth,
      });
    }

    render() {
      return (
        <WrappedComponent
          isDesktop={this.state.width > 1024}
          isExtraLarge={this.state.width >= 1400}
          isLargeDesktop={this.state.width >= 1200}
          isMobile={this.state.width < 768}
          isTablet={this.state.width >= 768 && this.state.width < 1024}
          windowHeight={this.state.height}
          windowWidth={this.state.width}
          {...this.props}
        />
      );
    }
  };
